import React from 'react';

import PageLayout from '@/components/layout/PageLayout';
import { Card } from '@/components/ui/cards';
import Table from '@/components/ui/tables/Table';
import { DateRangeFilter } from '@/components/ui/filters';
import { useTranslation } from '@/i18n';
import { useEnrollmentReport, ENROLLMENT_PAGE_SIZE_OPTIONS } from '@/hooks/attendance/report/useEnrollmentReport';
import { formatDateToYYYYMMDD } from '@/utils';


const MAX_HISTORY_YEARS = 5;

export const EnrollmentReport: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    columns,
    onDateRangeChange,
    dateFrom,
    dateTo,
    isLoading,
  } = useEnrollmentReport();

  const today = new Date();
  const maxDate = formatDateToYYYYMMDD(today);
  const minDateValue = new Date(today);
  minDateValue.setFullYear(minDateValue.getFullYear() - MAX_HISTORY_YEARS);
  const minDate = formatDateToYYYYMMDD(minDateValue);

  return (
    <PageLayout>
      <div className="flex flex-col gap-6" data-testid="enrollment-report-list-page">
        <Card>
          <div className="flex flex-col gap-4 p-4" data-testid="enrollment-report-filters">
            <DateRangeFilter
              value={{ from: dateFrom, to: dateTo }}
              onChange={onDateRangeChange}
              maxDate={maxDate}
              minDate={minDate}
              closeOnComplete
            />
          </div>
        </Card>

        <Table
          columns={columns}
          data={rows}
          totalRows={total}
          isLoading={isLoading}
          serverSideSort
          pagination={{
            page,
            pageSize,
            total,
            onChange: setPage,
            onPageSizeChange: setPageSize,
            pageSizeOptions: ENROLLMENT_PAGE_SIZE_OPTIONS,
          }}
          emptyMessage={translate('attendance:enrollmentReport.messages.empty')}
          data-testid="enrollment-report-table"
        />
      </div>
    </PageLayout>
  );
};

export default EnrollmentReport;
